module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Поиск по корреспонденту":"Search by correspondent","Идет поиск...":"Searching...","ваш аккаунт":"your account","Баланс":"Balance","Не удалось загрузить данные, попробуйте позже.":"Failed to load data, try again later."}}')
  delete Component.options._Ctor
}
